// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { 
	Box, 
	Image, 
	Divider, 
	Button, 
	Grid, 
	Text, 
	Flex,
	Modal,
	ModalOverlay,
	ModalCloseButton,
	ModalContent,
	useColorMode,
	useColorModeValue,
	useDisclosure,
	useBreakpointValue
} from '@chakra-ui/react';
import { NavLink, Link, useHistory } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import placeholder from 'assets/img/placeholder-partner.jpg';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';

// Components
import Card from 'components/Card/Card';
import LockedContent from '../discounts/components/LockedContent';

const AffiliatePartnerModal = ({ userData, item, isOpen, onOpen, onClose}) => {
	const backgroundLineImage = useBreakpointValue({ 
  		base: 'repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.10) 0px, rgba(255, 255, 255, 0.10) 10px, transparent 10px, transparent 20px)', 
  	});
  	const backgroundLineImageWhite = useBreakpointValue({ 
  		base: 'repeating-linear-gradient(90deg, #C8D3FF 0px, #C8D3FF 10px, transparent 10px, transparent 20px)', 
  	});
  	const bgDivider = useColorModeValue('white', '#0e1633');
  	const bgHalfCircleDivider = useColorModeValue('#CBE7FF', '#0e1325');
  	const borderColor = useColorModeValue('1px solid #CBE7FF', '1px solid #222840');
  	const textPartnerColor = useColorModeValue('#262D47', '#9FABCB');

  	const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

	const [isFetching, setIsFetching] = useState(false);

	const history = useHistory();

	const handleGoShopping = async () => {
	    setIsFetching(true);
	    window.location.href = item?.website; 
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
	        <ModalOverlay />
	        <ModalContent className="modal__simple modal_affiliate-partner" maxW={{ sm: '492px' }}>
	        	<ModalCloseButton />
	        	<Box 
	        		mt="44px" 
	        		position="relative" 
	        		overflow="hidden" 
	        		h={{base: !userData?.id ? '200px' : 'auto', md: 'auto'}} 
	        		borderRadius={{base: !userData?.id ? '16px' : 'unset', md: 'unset'}} 
	        		mb="24px">
		        	<Card padding="24px 16px 5px 16px" borderRadius="16px 16px 0 0" borderBottom="unset">
		        		<Box 
				            position="relative" 
				            w="100%" 
				            h="203px" 
				            borderRadius="16px" 
				            overflow="hidden"
				        >
		        			<Box
				                position="absolute"
				                w="100%"
				                h="100%"
				                backgroundImage={`url(${item?.image ?? placeholder})`}
				                backgroundSize="cover"
				                backgroundPosition="center"
				                filter="blur(20px)" 
				                transform="scale(1.2)"
				            />
				            <Image 
				                src={item?.image ?? placeholder} 
				                alt="partner" 
				                borderRadius="16px"
				                maxW="428px"
				                maxH="203px"
				                w="100%"
				                h="100%"
				                objectFit="contain"
				                position="relative"
				                zIndex="1"
				            />
		        		</Box>

		        		{ userData?.id && (
			        		<Box
			        			textAlign="center"
			        			zIndex="9"
			        			p="16px"
			        			mt="16px"
			        			borderRadius="16px"
								background={ isDark ? '#0D234D' : '#F5FAFF'}
								position="relative"
								overflow="hidden"
								border={ isDark ? 'unset' : '1px solid #CBE7FF'}
								boxShadow={ isDark ? '4px 4px 60px 0px rgba(0, 0, 0, 0.50)': 'unset'}>
								<Text mb="16px" variant="title-md" fontWeight="500" p={{ sm: '0px', md: '0 30px'}}>
									Click below to proceed to the store
								</Text>

								{ item?.id && item?.website ? (
									<Button
										onClick={handleGoShopping} 
			    						isLoading={isFetching} 
										variant={ isDark ? 'button-md-g' : 'button-md'}>
										Visit Store
									</Button>
								) : (
									<Button
										disabled={true}
										variant={ isDark ? 'button-md-g' : 'button-md'}>
										Coming soon
									</Button>
								)}

								<Lines className="abstract-lines" style={{ zIndex: '-1', top: '-230%', transform: 'rotate(259deg) scale(0.6)', right: '-30%', left: 'unset' }} />
			        		</Box>
		        		)}
		        	</Card>

	        		<Box bg={bgDivider} p="19px 24px" position="relative" overflow="hidden">
	        			<Box 
	        				bg={bgHalfCircleDivider} 
		        			border={borderColor} 
		        			w="45px" 
		        			h="45px" 
		        			borderRadius="full" 
		        			position="absolute" 
		        			top="-3px" 
		        			left="-32px" />
		        		<Box
							w="100%"
							h="1px"
							bg="transparent"
							position="relative"
							_before={{
								content: '""',
								position: 'absolute',
								width: '100%',
								height: '1px',
								backgroundImage: isDark ? backgroundLineImage : backgroundLineImageWhite,
							}}
						/>
						<Box 
							bg={bgHalfCircleDivider} 
		        			border={borderColor} 
		        			w="45px" 
		        			h="45px" 
		        			borderRadius="full" 
		        			position="absolute" 
		        			top="-3px" 
		        			right="-32px" />
					</Box>

					<Card padding="5px 16px 24px 16px" borderRadius="0 0 16px 16px" borderTop="unset">
						<Text color={textPartnerColor}>Affiliate Partner</Text>
						<Text variant="title-lg" fontSize="22px" fontWeight="700" mt="2px">{ item?.name }</Text>

						<Box mt="12px" mb="9px" borderTop={ isDark ? '1px solid rgba(255, 255, 255, 0.10)' : '1px solid #CBE7FF'} />

						{ userData?.id && (
							<Text>
								{ item?.description }
							</Text>
						)}
		        	</Card>

		        	{ !userData?.id && (<LockedContent />)}
		        </Box>

	        	{ userData?.id ? (<Button onClick={onClose} variant="secondary-md">Back</Button>) : (
	        		<Grid 
		        	templateColumns={{ sm: '1fr', md: '1fr 1fr'}} 
		        	gap="12px" 
		        	templateRows='1fr'>
		        		<Button onClick={onClose} variant="secondary-md">Back</Button>
		        		<NavLink to="/auth/login">
		        			<Button variant="button-md-g">Login to Unlock</Button>
		        		</NavLink>
		        	</Grid>
	        	) }
	        
	   	
	        </ModalContent>
	    </Modal> 
	);
};

export default AffiliatePartnerModal;